import * as moment from 'moment';
import { DateConverter } from 'src/app/core/services/mapper/converters';
import { ArrayClassConverterFactory, ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

/**
 * Id, Code Libelle
 **/
class Icl {
    static jsonMap = {
        id: 'id',
        code: { key: 'code', optional: true, default: '' },
        libelle: { key: 'libelle', optional: true, default: '' }
    };

    id: number;
    code: string;
    libelle: string;
}

/**
 * Id, actif, datedebut,
 **/
class Iad {
    static jsonMap = {
        id: { key: 'id', optional: true },
        actif: { key: 'actif', optional: true },
        dateDebut: { key: 'dateDebut', converter: new DateConverter(), optional: true }
    };

    id: number;
    actif: boolean;
    dateDebut: moment.Moment;
}

/**
 * Id, Libelle, actif, datedebut,
 **/
class Ilad extends Iad {
    static jsonMap = {
        ...Iad.jsonMap,
        libelle: { key: 'libelle', optional: true, default: '' }
    };

    libelle: string;
}

/**
 * Id, code, Libelle, actif, datedebut,
 **/
class Iclad extends Ilad {
    static jsonMap = {
        ...Ilad.jsonMap,
        code: { key: 'code', optional: true, default: '' }
    };

    code: string;
}

class Intervenant extends Iad {
    static jsonMap = {
        ...Iad.jsonMap,
        mail: { key: 'mail', optional: true, default: '' }
    };

    mail: string;
}

class Service extends Icl {
    static jsonMap = {
        ...Icl.jsonMap,
        libelleCourt: { key: 'libelleCourt', optional: true, default: '' }
    };

    libelleCourt: string;
}

class Fonctionnel extends Icl {
    static jsonMap = {
        ...Icl.jsonMap,
        roles: { key: 'roles', converter: new (ArrayClassConverterFactory.build(Icl))(), default: () => [] }
    };

    roles: Icl[];
}

class Organisme extends Iad {
    static jsonMap = {
        ...Iad.jsonMap,
        raisonSociale: { key: 'raisonSociale', optional: true, default: '' }
    };

    raisonSociale: string;
}

class Profil {
    static jsonMap = {
        domaine: { key: 'domaine', converter: new (ClassConverterFactory.build(Iclad))(), optional: true },
        intervenant: { key: 'intervenant', converter: new (ClassConverterFactory.build(Intervenant))(), optional: true },
        profil: { key: 'profil', converter: new (ClassConverterFactory.build(Ilad))(), optional: true },
        service: { key: 'service', converter: new (ClassConverterFactory.build(Service))(), optional: true },
        type: { key: 'type', converter: new (ClassConverterFactory.build(Iclad))(), optional: true },
        organisme: { key: 'organisme', converter: new (ClassConverterFactory.build(Organisme))(), optional: true }
    };

    domaine: Iclad = new Iclad();
    intervenant: Intervenant = new Intervenant();
    profil: Ilad = new Ilad();
    service: Service = new Service();
    type: Iclad = new Iclad();
    organisme: Organisme = new Organisme();
}

export class UtilisateurDroit {
    static jsonMap = {
        fonctionnels: { key: 'fonctionnels', converter: new (ArrayClassConverterFactory.build(Fonctionnel))(), default: () => [] },
        profil: { key: 'profil', converter: new (ClassConverterFactory.build(Profil))(), optional: true }
    };

    fonctionnels: Fonctionnel[];
    profil: Profil;
}
